// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"267":"a89f8e41","608":"efe6e18d","973":"5c8306a3"}[chunkId] + ".css";
};